export default __webpack_public_path__ + "static/media/asset.8483b104.png";